import { narrationSceneImageUrl } from '@/lib/sceneGridNarrationAdapter';

/**
 * Collect unique image / video / audio versions for a scene (active URL + *_history).
 * Image active URL uses the same narrationSceneImageUrl resolve as Scene / Editor.
 * @param {Record<string, unknown>} scene
 * @param {'image' | 'video' | 'audio'} kind
 */
export function collectSceneMediaVersions(scene, kind) {
  const mainKey = kind === 'image' ? 'image_url' : kind === 'video' ? 'video_url' : 'audio_url';
  const historyKey = kind === 'image' ? 'image_history' : kind === 'video' ? 'video_history' : 'audio_history';
  const activeUrl = kind === 'image'
    ? (narrationSceneImageUrl(scene) || scene?.[mainKey] || null)
    : (scene?.[mainKey] || null);
  const byUrl = new Map();

  const ensureEntry = (raw, sourceHint = null) => {
    if (!raw) return;
    const entry = typeof raw === 'string' ? { url: raw } : raw;
    if (!entry?.url) return;
    const existing = byUrl.get(entry.url) || {};
    byUrl.set(entry.url, {
      url: entry.url,
      createdAt: entry.created_at || existing.createdAt || null,
      source: entry.source || sourceHint || existing.source || null,
      isActive: existing.isActive || false,
    });
  };

  (scene[historyKey] || []).forEach((item) => ensureEntry(item));
  ensureEntry(
    {
      url: activeUrl,
      created_at: scene.updated_at || scene.created_at || null,
      source: 'active',
    },
    'active',
  );

  const versions = Array.from(byUrl.values()).map((entry) => ({
    ...entry,
    isActive: entry.url === activeUrl,
    createdAtMs: entry.createdAt
      ? new Date(entry.createdAt).getTime()
      : (entry.url === activeUrl ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY),
  }));

  versions.sort((a, b) => {
    if (a.createdAtMs !== b.createdAtMs) return b.createdAtMs - a.createdAtMs;
    if (a.isActive !== b.isActive) return a.isActive ? -1 : 1;
    return a.url.localeCompare(b.url);
  });
  return versions;
}
